
import React from 'react'
import Icon from 'react-icon-base'

const FaAngleUp = props => (
    <Icon viewBox="0 0 40 40" {...props}>
        <g><path d="m31 26.4q0 0.3-0.2 0.5l-1.1 1.2q-0.3 0.2-0.6 0.2t-0.5-0.2l-8.7-8.8-8.8 8.8q-0.2 0.2-0.5 0.2t-0.5-0.2l-1.2-1.2q-0.2-0.2-0.2-0.5t0.2-0.5l10.4-10.4q0.3-0.2 0.6-0.2t0.5 0.2l10.4 10.4q0.2 0.2 0.2 0.5z"/></g>
    </Icon>
)

export default FaAngleUp



// WEBPACK FOOTER //
// ./~/react-icons/fa/angle-up.js